import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';

import { ReceptStateModalComponent } from './recept-state-modal/recept-state-modal.component';
import { ReceptStateModalService } from './recept-state-modal/recept-state-modal.service';
import {
  ReceptSearchScreenActionSettingModalComponent
} from './recept-search-screen-action-setting-modal/recept-search-screen-action-setting-modal.component';
import {
  ReceptSearchScreenActionSettingService
} from './recept-search-screen-action-setting-modal/recept-search-screen-action-setting-modal.service';

@NgModule({
  imports: [CommonModule, BlNgUiComponentModule],
  exports: [ReceptStateModalComponent],
  declarations: [ReceptStateModalComponent, ReceptSearchScreenActionSettingModalComponent],
  entryComponents: [ReceptStateModalComponent, ReceptSearchScreenActionSettingModalComponent],
})
export class ReceptListModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ReceptListModalModule,
      providers: [ReceptStateModalService, ReceptSearchScreenActionSettingService],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/page/recept-list-page/modal/recept-list-modal.module.ts